export const messages = {
  en: {
    userDetailSeckillOrders: {
      orderId: 'Order ID',
      productImage: 'Product Image',
      productName: 'Product Name',
      buyer: 'Buyer',
      buyQuantity: 'Purchase Quantity',
      seckillAmount: 'Seckill Amount',
      buyTime: 'Purchase Time',
      status: 'Status',
      completed: 'Completed',
      pendingPayment: 'Pending Payment',
      deadline: 'Deadline'
    }
  },
  zh: {
    userDetailSeckillOrders: {
      orderId: '订单ID',
      productImage: '商品图片',
      productName: '商品名称',
      buyer: '购买者',
      buyQuantity: '购买数量',
      seckillAmount: '秒杀金额',
      buyTime: '购买时间',
      status: '状态',
      completed: '完成',
      pendingPayment: '待支付',
      deadline: '截止时间'
    }
  }
}